<template>
    <div class="campaigns">
        <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
            <svg class="icon" aria-hidden="true" style="color: #fff;">
        <use xlink:href="#icon-a-PaidPlacement"></use>
       
      </svg>
        </breadcrumbs>
        <div class="content-wrapper">
            <div class="table-head">
                <a-space class="filters">
                    <div class="statusFilter">
                        <span>brand:</span>
                        <a-input-search style="width: 180px;" v-model:value="params.brandName" placeholder="Search..."
                            allow-clear @search="onSearch" @enter="onSearch">
                        </a-input-search>
                    </div>
                    <div class="statusFilter">
                        <span>publisher:</span>
                        <a-input-search style="width: 180px;" v-model:value="params.publisherName"
                            placeholder="Search..." allow-clear @search="onSearch" @enter="onSearch">
                        </a-input-search>
                    </div>
                    <div class="statusFilter">
                        <span>placement:</span>
                        <a-input-search style="width: 180px;" v-model:value="params.placementName"
                            placeholder="Search..." allow-clear @search="onSearch" @enter="onSearch">
                        </a-input-search>
                    </div>
                    <div class="statusFilter">
                        <span>Status:</span>
                        <artmisads-select v-model:value="params.status" style="width: 180px;" @change="onStatusChange"
                            trigger="click">
                            <a-select-option value="">All</a-select-option>
                            <a-select-option value="BrandPaid">BrandPaid</a-select-option>
                            <a-select-option value="Paid">Paid</a-select-option>
                            <a-select-option value="PendingPayment">PendingPayment</a-select-option>
                            <a-select-option value="PendingAccept">PendingAccept</a-select-option>
                            <a-select-option value="Accepted">Accepted</a-select-option>
                            <a-select-option value="Refused">Refused</a-select-option>
                        </artmisads-select>
                    </div>
                </a-space>
            </div>
            <div class="table-data">
                <artmisads-table :loading="loading" :columns="columns" :data-source="data" :pagination="{
                    total: tableTotal,
                    current: params.page,
                    pageSize: params.size,
                    showTotal: (total, range) => `Total ${total} items`,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '50', '100', '200']
                }" :change="onChangePage">
                    <template #bodyCell="{ column, text, index, record }">
                        <template v-if="column.key === 'action'">
                           <artmisads-select-button size="small" @click="view(record)">View</artmisads-select-button>
                        </template>
                    </template>
                </artmisads-table>
            </div>

        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { financeApi } from "~/server/operator/finance"
import breadcrumbs from '@/components/breadcrumbs.vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const breadcrumbsData = {
    title: "Campaigns",
    des: "Manage your placements campaigns information",
    color: '#80C026',
    links: [
        {
            name: "Home",
            path: "/operator/users",
        },
        {
            name: "Paid Placement",
            path: "/operator/paidPlacement/placement",
        },
        {
            name: "Campaigns",
            path: "/operator/paidPlacement/campaigns",
        },
    ],
}
const columns = ref([
    {
        title: 'Brand',
        dataIndex: 'brandName',
        key: 'brandName',
    },
    {
        title: 'Publisher',
        dataIndex: 'publisherName',
        key: 'publisherName',
    },
    {
        title: 'PlacementName',
        dataIndex: 'placementName',
        key: 'placementName',
    },
    {
        title: 'Price',
        dataIndex: 'price',
        key: 'price',
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
    },
    {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        fixed: 'right',

    }

])
const data = ref([])
const loading = ref(false)
const tableTotal = ref(0)
const params = ref({
    page: 1,
    size: 10,
    brandName: '',
    publisherName: '',
    placementName: "",
    status: ""
})
const onChangePage = (pagination) => {
    params.value.page = pagination.current
    params.value.size = pagination.pageSize
    init()
    // 这里可以添加分页逻辑
}
const onStatusChange = (value) => {
    params.value.page = 1
    console.log(value,'status')
    params.value.status = value
    init()
}
const onSearch = () => {
    params.value.page = 1
    init()
}
const init = () => {
    loading.value = true
    financeApi.campaignsList(params.value).then(res => {
        console.log(res)
        data.value = res.data
        tableTotal.value = res.total
    }).finally(() => {
        loading.value = false
    })
}
const view = (record) => {
    router.push(`/operator/paidPlacement/campaigns/${record.id}`)
}
onMounted(() => {
    init()
})
</script>

<style scoped lang="less">
.table-data {

    border-radius: 8px;
    border: 1px solid #fff;
    border-radius: 12px;
    overflow: hidden;
    border-radius: 12px;
    background-color: var(--color-white);
    padding: 15px;

}

.campaigns {
    padding: 16px;
    padding-top: unset;
    width: 100%;

    .filters {
        display: flex;
        justify-content: space-between;

        .statusFilter {
            margin-left: 16px;
            display: flex;
            gap: 8px;
            align-items: center;
        }

    }

    .content-wrapper {
        display: block !important;

        .top-wrapper {
            display: flex;
            gap: 72px;
            align-items: center;

            .top-item {
                background-color: #d0f1ff;

                border-radius: 8px;

                .top-item-inner {
                    margin: 20px 0;
                    padding: 5px 10px;
                    border-left: 6px solid #55cfff;

                    .top-item-inner-title {
                        font-size: 16px;
                        font-weight: 600;

                    }

                    .top-item-inner-value {
                        font-size: 16px;
                        font-weight: 600;
                        margin-top: 6px;
                    }
                }

            }
        }

        .table-head {
            display: flex;
            height: 64px;
            justify-content: space-between;
            align-items: center;
        }
    }
}
</style>